/*----------------------------------------------------------------
  Handling files upload to S3 
  ----------------------------------------------------------------*/
import toast from 'react-hot-toast'

export const uploadToS3 = async (media) => {
    let uploadloading = toast.loading("Uploading File...");
    const apiUrl = process.env.REACT_APP_API_LINK + "/aws/presigned-url";
    const fileName = media?.name?.replace(/ /g, "-");
    const contentType = media?.type || "application/octet-stream";

    try {
        // 1. Get presigned URL from backend
        const presignedRes = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
            body: JSON.stringify({
                fileName,
                contentType,
            }),
        });

        if (!presignedRes.ok) {
            throw new Error("Failed to get presigned URL");
        }

        const { presignedUrl } = await presignedRes.json();

        // 2. Upload file to S3 using the presigned URL
        const uploadRes = await fetch(presignedUrl, {
            method: "PUT",
            headers: {
                "Content-Type": contentType,
            },
            body: media,
        });

        if (!uploadRes.ok) {
            throw new Error("Failed to upload file to S3");
        }

        toast.dismiss(uploadloading);
        toast.success("Your File Uploaded Successfully");

        // Remove query params from presignedUrl to get the S3 object URL
        const s3Url = presignedUrl.split('?')[0];
        return s3Url;
    } catch (err) {
        toast.dismiss(uploadloading);
        toast.error("File upload failed");
        return null;
    }
}